export default __webpack_public_path__ + "static/media/baseline-keyboard_arrow_left-24px.2566b7f8.svg";